import { render, staticRenderFns } from "./ProfileCompletionForm.vue?vue&type=template&id=06c28094"
import script from "./ProfileCompletionForm.vue?vue&type=script&lang=js"
export * from "./ProfileCompletionForm.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompletionForm.vue?vue&type=style&index=0&id=06c28094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports